import React, { useEffect, useState } from "react";

const API = "https://live-evo.com/api";
const SITE = "https://live-evo.com";

function AdminReportsWebPage() {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);

  const getMediaUrl = (path) => {
    if (!path) return "";

    const value = String(path);

    if (value.startsWith("http")) return value;
    if (value.startsWith("/uploads/")) return `${SITE}${value}`;
    if (value.startsWith("uploads/")) return `${SITE}/${value}`;

    return `${SITE}/uploads/${value.replace(/^\/+/, "")}`;
  };

  const loadReports = async () => {
    try {
      setLoading(true);

      const res = await fetch(`${API}/admin/reported-videos`);
      const data = await res.json();

      if (data.success) {
        setReports(data.reports || []);
      } else {
        setReports([]);
      }
    } catch (err) {
      console.error(err);
      alert("Impossible de charger les signalements");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadReports();
  }, []);

  const action = async (url, body, successMessage) => {
    try {
      const res = await fetch(`${API}/admin/reported-videos/${url}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
      });

      const data = await res.json();

      if (!data.success) {
        alert(data.message || "Action impossible");
        return;
      }

      alert(successMessage || data.message || "Action effectuée");
      loadReports();
    } catch (err) {
      console.error(err);
      alert("Serveur inaccessible");
    }
  };

  const visibleReports = reports.filter((item) => {
    return String(item.report_status || "").toLowerCase() !== "ferme";
  });

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#020b14",
        padding: 18,
        color: "#fff"
      }}
    >
      <div style={{ maxWidth: 1300, margin: "0 auto" }}>
        <h1
          style={{
            color: "#ff0033",
            fontSize: 22,
            fontWeight: "bold",
            marginBottom: 18,
            textAlign: "center"
          }}
        >
          🚨 MODÉRATION VIDÉOS SIGNALÉES
        </h1>

        {loading ? (
          <div style={{ color: "#00f2ff", textAlign: "center", marginTop: 40 }}>
            Chargement...
          </div>
        ) : visibleReports.length === 0 ? (
          <div style={{ color: "#8fa6ad", textAlign: "center", marginTop: 40 }}>
            Aucun signalement à traiter.
          </div>
        ) : (
          visibleReports.map((item) => {
            const videoUrl = getMediaUrl(item.file_path);
            const thumbUrl = getMediaUrl(item.thumbnail);

            return (
              <div
                key={item.report_id}
                style={{
                  background: "#051626",
                  padding: 16,
                  borderRadius: 12,
                  marginBottom: 18,
                  border: "1px solid #1a2b3c"
                }}
              >
                <div
                  style={{
                    color: "#fff",
                    fontWeight: "bold",
                    marginBottom: 10,
                    fontSize: 16
                  }}
                >
                  🚨 Signalement #{item.report_id}
                </div>

                <div style={gridStyle}>
                  <div style={infoBoxStyle}>
                    <div style={labelStyle}>👤 Signalé par</div>
                    <div style={valueStyle}>
                      {item.reporter_pseudo || "inconnu"}
                    </div>
                    <div style={mutedStyle}>{item.reporter_email}</div>
                  </div>

                  <div style={infoBoxStyle}>
                    <div style={labelStyle}>🎥 Auteur signalé</div>
                    <div style={valueStyle}>
                      {item.video_owner_pseudo || "inconnu"}
                    </div>
                    <div style={mutedStyle}>{item.video_owner_email}</div>
                  </div>

                  <div style={infoBoxStyle}>
                    <div style={labelStyle}>📌 Statut</div>
                    <div style={statusStyle}>
                      {(item.report_status || "ouvert").toUpperCase()}
                    </div>
                    <div style={mutedStyle}>
                      Vidéo : {item.video_status || "inconnu"}
                    </div>
                  </div>
                </div>

                <div style={{ marginTop: 12 }}>
                  <div style={textStyle}>
                    <strong>Motif :</strong> {item.reason || "Aucun motif"}
                  </div>
                  <div style={textStyle}>
                    <strong>Vidéo ID :</strong> {item.video_id}
                  </div>
                  <div style={textStyle}>
                    <strong>Titre / description :</strong>{" "}
                    {item.video_title || item.video_description || item.description || "Sans titre"}
                  </div>
                </div>

                <div
                  style={{
                    marginTop: 14,
                    background: "#000",
                    borderRadius: 10,
                    overflow: "hidden",
                    border: "1px solid #123"
                  }}
                >
                  {videoUrl ? (
                    <video
                      src={videoUrl}
                      poster={thumbUrl || undefined}
                      controls
                      style={{
                        width: "100%",
                        maxHeight: 520,
                        background: "#000"
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        padding: 35,
                        color: "#777",
                        textAlign: "center"
                      }}
                    >
                      Vidéo introuvable
                    </div>
                  )}
                </div>

                {videoUrl && (
                  <a
                    href={videoUrl}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      display: "inline-block",
                      color: "#00f2ff",
                      marginTop: 10,
                      fontWeight: "bold",
                      textDecoration: "none"
                    }}
                  >
                    🔗 Ouvrir la vidéo
                  </a>
                )}

                <div
                  style={{
                    display: "flex",
                    gap: 8,
                    marginTop: 14,
                    flexWrap: "wrap"
                  }}
                >
                  <button
                    style={{ ...btnStyle, background: "#ffaa00" }}
                    onClick={() =>
                      action(
                        "status",
                        {
                          report_id: item.report_id,
                          status: "en_cours",
                          admin_response: "Signalement en cours de traitement"
                        },
                        "Signalement passé en cours"
                      )
                    }
                  >
                    En cours
                  </button>

                  <button
                    style={{ ...btnStyle, background: "#6f42c1" }}
                    onClick={() =>
                      action(
                        "hide-video",
                        { video_id: item.video_id },
                        "Vidéo masquée / restreinte"
                      )
                    }
                  >
                    Masquer
                  </button>

                  <button
                    style={{ ...btnStyle, background: "#00c853" }}
                    onClick={() =>
                      action(
                        "resolve",
                        {
                          report_id: item.report_id,
                          admin_response: "Signalement vérifié et fermé"
                        },
                        "Signalement fermé"
                      )
                    }
                  >
                    Fermer
                  </button>

                  <button
                    style={{ ...btnStyle, background: "#009688" }}
                    onClick={() =>
                      action(
                        "restore-video",
                        { video_id: item.video_id },
                        "Vidéo restaurée"
                      )
                    }
                  >
                    Restaurer
                  </button>

                  <button
                    style={{ ...btnStyle, background: "#ff0033" }}
                    onClick={() => {
                      const ok = window.confirm("Supprimer cette vidéo et fermer les signalements liés ?");
                      if (!ok) return;

                      action(
                        "delete-video",
                        { video_id: item.video_id },
                        "Vidéo supprimée"
                      );
                    }}
                  >
                    Supprimer
                  </button>
                </div>
              </div>
            );
          })
        )}

        <button
          onClick={() => {
            window.location.href = "/admin";
          }}
          style={{
            background: "#007bff",
            padding: 12,
            borderRadius: 8,
            border: "none",
            color: "#fff",
            fontWeight: "bold",
            width: "100%",
            marginTop: 10,
            cursor: "pointer"
          }}
        >
          ← Retour Admin
        </button>
      </div>
    </div>
  );
}

const gridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
  gap: 10
};

const infoBoxStyle = {
  background: "#020b14",
  border: "1px solid #123047",
  borderRadius: 10,
  padding: 10
};

const labelStyle = {
  color: "#8fa6ad",
  fontSize: 12,
  marginBottom: 4
};

const valueStyle = {
  color: "#fff",
  fontSize: 15,
  fontWeight: "bold"
};

const mutedStyle = {
  color: "#7f95a5",
  fontSize: 12,
  marginTop: 3,
  wordBreak: "break-word"
};

const statusStyle = {
  color: "#ffcc00",
  fontSize: 15,
  fontWeight: "bold"
};

const textStyle = {
  color: "#c9d6df",
  fontSize: 13,
  marginTop: 5
};

const btnStyle = {
  flex: 1,
  minWidth: 120,
  padding: 10,
  borderRadius: 6,
  border: "none",
  color: "#fff",
  fontSize: 12,
  fontWeight: "bold",
  cursor: "pointer"
};

export default AdminReportsWebPage;
